module.exports = __webpack_public_path__ + "img/black.f3261085.svg";